import React from 'react';
import {Link} from 'react-router-dom';
import Lightbox from "yet-another-react-lightbox";
import MetaTags from "../components/MetaTags";

const Bousi: React.FC = () => {
    const [open, setOpen] = React.useState(false);
    const [image, setImage] = React.useState<number>(0);

    const images = [
        {src: "/image/Bousi/kP1220106.jpg"},
        {src: "/image/Bousi/kPA140029.jpg"},
        {src: "/image/Bousi/kP3120089.jpg"},
        {src: "/image/Bousi/kP5090007.jpg"},
        {src: "/image/Bousi/kP3120094.jpg"},
        {src: "/image/Bousi/kP3120101.jpg"},
        {src: "/image/Bousi/kP3120096.jpg"},
        {src: "/image/Bousi/kP3120091.jpg"},
    ];

    const viewImage = (event: any) => {
        setOpen(true)
        setImage(Number(event.target.id.replace(/\D/g, '')))
    }

    MetaTags(
        "Колье и бусы из бисера",
        "Колье и бусы из бисера. Кулон в виде улитки на основе квадратного столбика, колье на основе шнура, колье из цветочков, колье из треугольной цепочки. " +
        "Колье и бусы из бисера. Кулон в виде улитки на основе квадратного столбика, колье на основе шнура, колье из цветочков, колье из треугольной цепочки."
    )

    return <>
        <h2>Колье и бусы из бисера</h2>
        <div className="row catalog">
            <div className="col-sm-4 col-lg-3 padding-side">
                <img src="/image/Bousi/mP1220106.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="170" height="227"
                     alt="Ажурный комплект на основе шнура"
                     id="image-0"
                     onClick={viewImage}
                />
                <p className="name">Ажурный комплект</p>

            </div>
            <div className="col-sm-4 col-lg-3 padding-side">
                <img src="/image/Bousi/mPA140029.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="170" height="227"
                     alt="Кулон Улитка"
                     id="image-1"
                     onClick={viewImage}
                />
                <p className="name">Кулон "Улитка"</p>

            </div>
            <div className="col-sm-4 col-lg-3 padding-side">
                <img src="/image/Bousi/mP3120089.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="170" height="227"
                     alt="Колье 11 цветов"
                     id="image-2"
                     onClick={viewImage}
                />
                <p className="name">Колье "11 цветов"</p>

            </div>
            <div className="col-sm-4 col-lg-3 padding-side">
                <img src="/image/Bousi/mP5090007.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="170" height="227"
                     alt="Колье из цветочков"
                     id="image-3"
                     onClick={viewImage}
                />
                <p className="name">Колье из цветочков</p>
            </div>
            <div className="col-sm-4 col-lg-3 padding-side">
                <img src="/image/Bousi/mP3120094.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="170" height="227"
                     alt="Колье Трехцветное"
                     id="image-4"
                     onClick={viewImage}
                />
                <p className="name">Колье "Трехцветное"</p>

            </div>
            <div className="col-sm-4 col-lg-3 padding-side">
                <img src="/image/Bousi/mP3120101.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="170" height="227"
                     alt="Разноцветные бусы"
                     id="image-5"
                     onClick={viewImage}
                />
                <p className="name">Разноцветные бусы</p>

            </div>
            <div className="col-sm-4 col-lg-3 padding-side">
                <img src="/image/Bousi/mP3120096.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="170" height="227"
                     alt="Колье из плотного шнура"
                     id="image-6"
                     onClick={viewImage}
                />
                <p className="name">Колье из шнура</p>

            </div>
            <div className="col-sm-4 col-lg-3 padding-side">
                <img src="/image/Bousi/mP3120091.jpg"
                     className="img-rounded img-responsive col-centered"
                     width="170" height="227"
                     alt="Кулон в технике полотно"
                     id="image-7"
                     onClick={viewImage}
                />
                <p className="name">Кулон из полотна</p>
            </div>
        </div>

        <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={[
                images[image], // Выбранный элемент
                ...images.slice(0, image), // Элементы до выбранного
                ...images.slice(image + 1) // Элементы после выбранного
            ]}
        />
    </>;
};

export default Bousi;

